import { Col, InputGroup, Form, Row } from 'react-bootstrap'
import { camelCase } from 'lodash'
import * as Yup from 'yup'

type Values = {
  id: number
  columns: number
  paragraphStyleSettingType: string
  name: string
}

type EnumValues = {
  paragraphStyleSettingTypes: Record<string, string>
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleSubmit: (values: Values) => void
  enumValues: EnumValues
  isSettingWritable: boolean
  rowIndex: number
}

const _ParagraphStyleSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleSubmit,
  enumValues,
  isSettingWritable,
  rowIndex
}: Props) => {
  if (!values) {
    return <></>
  }
  const columnString = values?.columns === 0 ? '' : `${values?.columns}段`
  const typeString = enumValues.paragraphStyleSettingTypes[camelCase(values?.paragraphStyleSettingType)]
  const combinedColumnString = `${columnString}${typeString}`
  return (
    <Row sm='auto' className={`row-${rowIndex + 1}`}>
      <Col sm={2}>{combinedColumnString}</Col>
      <Col>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            id={`nameInput-${values.id}`}
            type='text'
            name='name'
            value={values.name || ''}
            onBlur={(_) => handleSubmit(values)}
            onChange={handleChange}
            isInvalid={!!(touched.name && errors.name)}
            disabled={!isSettingWritable}
          />
          <Form.Control.Feedback type='invalid'>{errors.name}</Form.Control.Feedback>
        </InputGroup>
      </Col>
    </Row>
  )
}

export const ParagraphStyleSettingForm = Object.assign(_ParagraphStyleSettingForm, {
  schema: Yup.object().shape({
    name: Yup.string().trim().required()
  })
})
